var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg61(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7698_9414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9373 15.8009H19.4998V16.921H14.9373C12.8975 16.9212 11.1814 18.322 10.697 20.212H9.54858C10.0541 17.6996 12.2786 15.801 14.9373 15.8009Z",
    fill: "#1A1A1A",
    stroke: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4141 12.0093H14.9376C10.0122 12.0093 5.96987 15.8621 5.66675 20.7124H7.79198C8.0912 17.0324 11.1817 14.129 14.9376 14.129H20.0001V12.5952C20.0001 12.2716 19.7377 12.0093 19.4141 12.0093Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2957 20.7124H19.414C19.7376 20.7124 20 20.4501 20 20.1265V18.5926H14.9375C13.6467 18.5926 12.5641 19.5012 12.2957 20.7124Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15.3009V17.4207H5.22199C5.52387 16.6671 5.91102 15.9565 6.37145 15.3009H0Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 20.1265C0 20.4501 0.262344 20.7124 0.585938 20.7124H4.49328C4.53371 19.9835 4.64934 19.2745 4.83211 18.5926H0V20.1265Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43234 10.8373H11.5679L13.6788 6.75184C14.3372 5.47731 14.2827 3.92438 13.5366 2.6991C11.9588 0.0687134 8.04155 0.0682447 6.46363 2.6991C5.71753 3.92438 5.66308 5.47731 6.32144 6.75188L8.43234 10.8373ZM9.95843 4.16422C10.2819 4.16422 10.5444 4.42672 10.5444 4.75016C10.5133 5.52735 9.40347 5.52711 9.37249 4.75016C9.37249 4.42672 9.63499 4.16422 9.95843 4.16422Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1305 12.0093H0.585938C0.262344 12.0093 0 12.2716 0 12.5952V14.1291H7.32699C8.13234 13.2746 9.07945 12.5554 10.1305 12.0093Z",
    fill: "#1A1A1A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7698_9414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.719238)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg61);
export default __webpack_public_path__ + "static/media/svg61.7893bba111315772d4c55e0c912b2498.svg";
export { ForwardRef as ReactComponent };